/* AP — ap-content.js (lot D). IIFE, defer, aucune dépendance.
   1. Avis : « Show more » (masque au-delà de data-initial, dévoile par paliers) + dialog photo.
   2. Ancre : ouvre le <details> visé par le hash (FAQ #units, #software…) et rend le focus au statut du formulaire de contact.
   Sans JS : tous les avis sont visibles, les photos s'ouvrent dans un nouvel onglet, les accordéons restent natifs. */
(function () {
  'use strict';

  function initReviews(section) {
    if (section.__apReviews) return;
    section.__apReviews = true;
    var initial = parseInt(section.getAttribute('data-initial'), 10) || 6;
    var cards = [].slice.call(section.querySelectorAll('[data-apr-card]'));
    var btn = section.querySelector('[data-apr-more]');
    var shown = initial;

    function apply() {
      cards.forEach(function (card, i) { card.hidden = i >= shown; });
      if (btn) btn.hidden = shown >= cards.length;
    }
    if (cards.length > initial) {
      apply();
      if (btn) {
        btn.addEventListener('click', function () {
          var first = cards[shown];
          shown = Math.min(cards.length, shown + initial);
          apply();
          if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: false }); }
        });
      }
    }

    var dialog = section.querySelector('[data-apr-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('[data-apr-dialog-img]');
    var opener = null;
    section.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('[data-apr-photo]') : null;
      if (!link || !section.contains(link)) return;
      e.preventDefault();
      var thumb = link.querySelector('img');
      img.src = link.href;
      img.alt = thumb ? thumb.alt : '';
      opener = link;
      dialog.showModal();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-apr-close]'))) dialog.close();
    });
    dialog.addEventListener('close', function () {
      img.removeAttribute('src');
      if (opener) opener.focus();
    });
  }

  function openHashTarget() {
    var hash = location.hash;
    if (!hash || hash.length < 2) return;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (err) { return; }
    var el = document.getElementById(id);
    if (!el) return;
    var details = el.closest ? el.closest('details') : null;
    if (details && !details.open) details.open = true;
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-ap-reviews]'), initReviews);
    openHashTarget();
    var status = document.querySelector('[data-apc-status]');
    if (status) status.focus({ preventScroll: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('hashchange', openHashTarget);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ap-reviews]') : null;
    if (root) initReviews(root);
  });
})();
